var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.attachments),function(file,i){return _c('attachment-file-item',{key:i,attrs:{"index":_vm.index,"subIndex":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }